import React, { Component, Fragment } from 'react';
import { Table, Jumbotron, Row, Col, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaRegCopy, FaCheck } from 'react-icons/fa';
// ;
import config from '../../config';
import { CSVLink } from "react-csv";

export class ReporteDetalladoNomina extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            info: [],
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            empresa: currentCompany,
            copiedIndex: null
        }
    }

    copyCune = (cune, index) => {
        if (!cune) return;
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(cune).then(() => {
                this.setState({ copiedIndex: index });
                setTimeout(() => this.setState({ copiedIndex: null }), 1800);
            }).catch(err => {
                console.error("Error al copiar CUNE:", err);
                this.fallbackCopyText(cune, index);
            });
        } else {
            this.fallbackCopyText(cune, index);
        }
    }

    fallbackCopyText = (text, index) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            this.setState({ copiedIndex: index });
            setTimeout(() => this.setState({ copiedIndex: null }), 1800);
        } catch (err) {
            console.error('Fallback: Error al copiar', err);
        }
        document.body.removeChild(textArea);
    }

    updateReport = () => {
        const { fecha_inicial, fecha_final, empresa } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                fecha_inicial,
                fecha_final,
                empresa
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }

        fetch(config.servBackEnd + '/reports/detailnomina', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const info = (data.data || []).sort((a, b) => {
                        const prefijoCompare = (a.TIPO_DOCUMENTO_CABECERA || '').localeCompare(b.TIPO_DOCUMENTO_CABECERA || '');
                        if (prefijoCompare !== 0) return prefijoCompare;
                        return (Number(a.NUMERO_FACTURA_CABECERA) || 0) - (Number(b.NUMERO_FACTURA_CABECERA) || 0);
                    });
                    this.setState({ info })
                } else {
                    this.setState({ info: [] })
                }
            })
            .catch((error) => console.error(error))
    }

    render() {
        const { info } = this.state;
        const csvData = info.map(element => ({
            "NIT EMPLEADO": element.DOCUMENTO_CLIENTE,
            "NOMBRE EMPLEADO": element.NOMBRE_CLIENTE,
            "DOCUMENTO": (element.TIPO_DOCUMENTO_CABECERA || '') + "-" + (element.NUMERO_FACTURA_CABECERA || ''),
            "FECHA": element.FECHA_DOCUMENTO,
            "DEVENGADO": element.DEVENGADO_TOTAL,
            "DEDUCIDO": element.DEDUCCIONES_TOTAL,
            "TOTAL": element.COMPROBANTE_TOTAL,
            "CUNE": element.CUFE || element.CUNE || ''
        }));

        return (
            <Fragment>

                <Jumbotron className="Jumbotron">
                    <h2>Reporte Consolidado Empleados</h2>
                </Jumbotron>
                <Row>
                    <Col>
                        Fecha Inicial <Form.Control type="date" onChange={(e) => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} />
                    </Col>
                    <Col>
                        Fecha Final <Form.Control type="date" onChange={(e) => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} />
                    </Col>
                    <Col>
                        <Button variant="primary" className="m-3" onClick={this.updateReport} >Genera Informe</Button>
                    </Col>
                    <Col>
                        <CSVLink data={csvData} filename={"REPORTE_CONSOLIDADO_EMPLEADOS.csv"} separator={";"}>
                            <Button disabled={info.length === 0} variant="success">Descargar Reporte</Button>
                        </CSVLink>
                    </Col>
                </Row>
                <Table className="tableFixHead">
                    <thead>
                        <tr>
                            <th>NIT EMPLEADO</th>
                            <th>NOMBRE EMPLEADO</th>
                            <th>DOCUMENTO</th>
                            <th>FECHA</th>
                            <th>DEVENGADO</th>
                            <th>DEDUCIDO</th>
                            <th>TOTAL</th>
                            <th style={{ textAlign: 'center' }}>CUNE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            info.map((element, index) => {
                                const cune = element.CUFE || element.CUNE || '';
                                return (
                                    <tr key={index}>
                                        <td>{element.DOCUMENTO_CLIENTE}</td>
                                        <td>{element.NOMBRE_CLIENTE}</td>
                                        <td>{element.TIPO_DOCUMENTO_CABECERA + "-" + element.NUMERO_FACTURA_CABECERA}</td>
                                        <td>{element.FECHA_DOCUMENTO}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.DEVENGADO_TOTAL)}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.DEDUCCIONES_TOTAL)}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.COMPROBANTE_TOTAL)}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            {cune ? (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-cune-${index}`}>
                                                            {this.state.copiedIndex === index ? "¡Copiado al portapapeles!" : `Copiar CUNE: ${cune.substring(0, 16)}...`}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <Button
                                                        variant={this.state.copiedIndex === index ? "success" : "light"}
                                                        size="sm"
                                                        style={{ 
                                                            padding: '4px 8px', 
                                                            borderRadius: '6px', 
                                                            display: 'inline-flex', 
                                                            alignItems: 'center', 
                                                            justifyContent: 'center',
                                                            lineHeight: 1,
                                                            color: this.state.copiedIndex === index ? '#fff' : 'inherit',
                                                            backgroundColor: this.state.copiedIndex === index ? '#28a745' : 'transparent',
                                                            borderColor: this.state.copiedIndex === index ? '#28a745' : '#ced4da'
                                                        }}
                                                        onClick={() => this.copyCune(cune, index)}
                                                    >
                                                        {this.state.copiedIndex === index ? (
                                                            <FaCheck size={14} />
                                                        ) : (
                                                            <FaRegCopy size={14} />
                                                        )}
                                                    </Button>
                                                </OverlayTrigger>
                                            ) : (
                                                <span style={{ color: '#999' }}>-</span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
            </Fragment>
        )
    }
}

export default ReporteDetalladoNomina



// WEBPACK FOOTER //
// ./src/components/nomina/ReporteDetallado.jsx